export enum CouponAccountValidity {
	ForB2c = "ForB2c",
	ForB2b = "ForB2b",
	ForBoth = "ForBoth",
}
